import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';

// 覆盖鲸海蓝主色调
var getTagStyle = function getTagStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary,
    primary1 = _getThemeData.primary1,
    primary7 = _getThemeData.primary7;
  return css([".c7n-tag{div&{background-color:", ";border-color:", ";color:#fff;}&.c7n-tag-checkable:not(.c7n-tag-checkable-checked){color:", ";background-color:", ";border-color:", ";&:active{background-color:", " !important;}}&.c7n-tag-checkable-checked{background-color:", ";&:active{background-color:", ";}}}"], primary, primary, primary, primary1, primary1, primary7, primary, primary);
};
var hzeroTagStyle = function hzeroTagStyle(props) {
  var _getThemeData2 = getThemeData(props, 'common'),
    primary = _getThemeData2.primary,
    primary1 = _getThemeData2.primary1,
    primary7 = _getThemeData2.primary7;
  return css(["[class='ant-tag']{background-color:", ";border-color:", ";color:#fff;.anticon-cross{color:#fff;}}.ant-tag{&&-checkable{&:not(.ant-tag-checkable-checked){color:", ";background-color:", ";border-color:", ";}&:active{background-color:", " !important;}&.ant-tag-checkable-checked{background-color:", ";}}}"], primary, primary, primary, primary1, primary1, primary7, primary);
};
var tagData = {
  name: 'tag',
  data: [{}],
  // 不使用主题5模板，只需要在鲸海蓝基础上修改颜色即可
  onlyTemplate: {
    base: getTagStyle,
    hzero: hzeroTagStyle
  }
};
export default tagData;